<template>
<div :key="forceUpdateCounter">
  <HeaderControls :myWeek='true' @filterUpdated='filterUpdate' @collapseToggleUpdated='collapseToggleUpdate' />
  <div class="container-fluid">
    <DeliverableList :filterQuery="filterQuery" :myWeek="true" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate' />
  </div>
  </div>
</template>
<script>
import DeliverableList from "../components/deliverables/List";
import Logo from "../components/common/Logo";
import HeaderControls from "../components/common/HeaderControls";
import { mapState } from 'vuex';

export default {
  data() {
    return {
      filterQuery: {
        query: "",
        filterByDate: false,
        filterByDateCreated: false,
        filterByDateCompleted: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        status: [],
        outlet: [],
        deliverableType: [],
        tag: [],
        department: [],
        coordinator: []
      },
      expandAll: !this.isMobile()
    }
  },
  computed: {
    forceUpdateCounter() {
      return this.$store.state.deliverables.forceUpdateCounter
    }
  },
  components: {
    DeliverableList,
    Logo,
    HeaderControls
  },
  methods: {
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery
    },
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    }
  }
};
</script>